<template>
  <el-card>
    <div slot="header">
      <div class="page-hedaer">
        <h4 class="page-title">系统设置</h4>
        <span class="title-info"></span>
      </div>
    </div>

    <el-form :model="settings" label-width="150px">
      <el-divider content-position="left">分销比例设置</el-divider>

      <el-form-item label="用户自得比例">
        <el-input-number
          v-model="settings.distribution_self_ratio"
          :min="0"
          :max="100"
          :step="1"
        ></el-input-number>
        <span style="margin-left: 10px">%</span>
      </el-form-item>

      <el-form-item label="上级分成比例">
        <el-input-number
          v-model="settings.distribution_parent_ratio"
          :min="0"
          :max="100"
          :step="1"
        ></el-input-number>
        <span style="margin-left: 10px">%</span>
      </el-form-item>

      <el-form-item label="上上级分成比例">
        <el-input-number
          v-model="settings.distribution_grandparent_ratio"
          :min="0"
          :max="100"
          :step="1"
        ></el-input-number>
        <span style="margin-left: 10px">%</span>
      </el-form-item>

      <el-divider content-position="left">商品设置</el-divider>

      <el-form-item label="提升商品比例点数">
        <el-input-number
          v-model="settings.goods_boost_points"
          :min="0"
          :max="100"
          :step="1"
        ></el-input-number>
        <div class="form-tip" style="font-size: 12px">
          在商品佣金基础上额外增加的分成比例点数
        </div>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="saveSettings" :loading="saving"
          >保存设置</el-button
        >
      </el-form-item>
    </el-form>
    <el-button type="primary" :loading="loading4" @click="getToken">同步TOKEN</el-button>
    <el-button type="primary" :loading="loading1" @click="syncOrder">同步订单</el-button>
    <el-button type="primary" :loading="loading2" @click="syncGoods">同步商品</el-button>
    <el-button type="primary" :loading="loading3" @click="syncCommissions">结算补贴</el-button>
  </el-card>
</template>

<script>
import api from "../../api";

export default {
  name: "Settings",
  data() {
    return {
      settings: {
        distribution_self_ratio: 0,
        distribution_parent_ratio: 0,
        distribution_grandparent_ratio: 0,
        goods_boost_points: 0,
      },
      saving: false,
      loading1:false,
      loading2:false,
      loading3:false,
      loading4:false
    };
  },
  async created() {
    this.fetchSettings();
  },
  methods: {
    async fetchSettings() {
      try {
        const { data } = await api.get("/api/admin/settings");
        this.settings = {
          distribution_self_ratio: data.distribution_self_ratio ?? 90,
          distribution_parent_ratio: data.distribution_parent_ratio ?? 5,
          distribution_grandparent_ratio:
            data.distribution_grandparent_ratio ?? 5,
          goods_boost_points: data.goods_boost_points ?? 0,
        };
      } catch (e) {
        console.error(e);
      }
    },
     
    async syncOrder() {
      this.loading1 = true;
      try {
        await api.post("/api/tasks/sync-orders");
        this.$message.success("操作成功");
      } catch (e) {
        this.$message.error("操作失败");
      } finally {
        this.loading1 = false;
      }
    },
    async syncGoods() {
      this.loading2 = true;
      try {
        await api.post("/api/tasks/sync-products");
        this.$message.success("操作成功");
      } catch (e) {
        this.$message.error("操作失败");
      } finally {
        this.loading2 = false;
      }
    },
    async syncCommissions() {
      this.loading3 = true;
      try {
        await api.post("/api/tasks/sync-commissions");
        this.$message.success("操作成功");
      } catch (e) {
        this.$message.error("操作失败");
      } finally {
        this.loading3 = false;
      }
    },
    async getToken() {
      this.loading4 = true;
      try {
        await api.post("/api/tasks/get-auth-token");
        this.$message.success("操作成功");
      } catch (e) {
        this.$message.error("操作失败");
      } finally {
        this.loading4 = false;
      }
    },
    async saveSettings() {
      this.saving = true;
      try {
        await api.post("/api/admin/settings", this.settings);
        this.$message.success("设置保存成功");
      } catch (e) {
        this.$message.error("保存失败");
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>
<style scoped>
.page-hedaer {
  display: flex;
  align-items: center;
  min-height: 32px;
}
.page-title {
  margin: 0;
}
.title-info {
  color: #909399;
  margin-left: 5px;
  font-size: 12px;
}
</style>
